import { motion } from 'framer-motion';
import { useInView } from '../store/hooks';

export default function About() {
  const { ref, isInView } = useInView(0.15);

  return (
    <section id="about" ref={ref} className="py-28 sm:py-36 relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left column */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <span className="inline-block text-xs font-body font-semibold tracking-[0.25em] uppercase text-[#c8ff00] mb-4">
              About Us
            </span>
            <h2 className="font-display text-4xl sm:text-5xl font-bold text-white leading-tight mb-6">
              We don't just build websites.
              <br />
              <span className="text-gradient italic">We build leverage.</span>
            </h2>
          </motion.div>

          {/* Right column */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.4 }}
            className="space-y-6"
          >
            <p className="font-body text-surface-300 text-lg leading-relaxed">
              Prime Web is a premium digital agency built around one belief: your website
              should be your hardest-working asset. We operate at the intersection of strategy,
              design, and modern technology to deliver digital experiences that actually move the needle.
            </p>
            <p className="font-body text-surface-400 leading-relaxed">
              Behind every project is a carefully orchestrated team of world-class designers and
              developers, managed with precision to ensure nothing falls through the cracks.
              We act as the bridge between ambitious vision and flawless execution — handling
              every detail so our clients can focus on growing their business.
            </p>
            <p className="font-body text-surface-400 leading-relaxed">
              We leverage the latest tools, AI-powered workflows, and battle-tested design systems
              to deliver results faster without compromising quality. Speed, clarity, and measurable
              outcomes — that's the standard we hold ourselves to on every engagement.
            </p>

            {/* Values grid */}
            <div className="grid grid-cols-2 gap-4 pt-6">
              {[
                { title: 'Results-Driven', desc: 'Every decision serves a business goal' },
                { title: 'Fast Delivery', desc: 'Weeks, not months' },
                { title: 'AI-Enhanced', desc: 'Modern tools, smarter workflows' },
                { title: 'Client-First', desc: '98% satisfaction rate' },
              ].map((v, i) => (
                <motion.div
                  key={v.title}
                  initial={{ opacity: 0, y: 20 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.6 + i * 0.1 }}
                  className="glass-card-light rounded-xl p-4"
                >
                  <div className="font-body font-semibold text-white text-sm">{v.title}</div>
                  <div className="font-body text-surface-500 text-xs mt-1">{v.desc}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
